export default "__VITE_ASSET__CMmu5fJh__"